// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"5379715a","282":"094ff15a","454":"c20bdf29"}[chunkId] + ".chunk.js";
};